import { Component, Input, NgZone, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '../../../../../services/nav.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { NavItem } from '../../../vertical/sidebar/nav-item/nav-item';
import { AdminShellModeService } from '@core/shell/admin-shell-mode.service';
import {
  ConfirmOpenTabDialogComponent,
  ConfirmOpenTabDialogData,
} from '@shared/ui/confirm-open-tab-dialog/confirm-open-tab-dialog.component';
import {
  isPosShellEntryRoute,
  POS_VENTA_ENTRY_ROUTE,
} from '@shared/ui/confirm-open-tab-dialog/confirm-enter-pos';

@Component({
  selector: 'app-horizontal-nav-item',
  imports: [CommonModule, MatIconModule, MatDialogModule, TranslateModule],
  templateUrl: './nav-item.component.html',
})
export class AppHorizontalNavItemComponent {
  private readonly ngZone = inject(NgZone);
  private readonly dialog = inject(MatDialog);
  private readonly adminShellMode = inject(AdminShellModeService);

  @Input() depth = 0;
  @Input() item: NavItem = {};

  constructor(public navService: NavService, public router: Router) {
    this.depth = 0;
  }

  onItemSelected(item: NavItem, event?: MouseEvent) {
    event?.preventDefault();
    event?.stopPropagation();

    if (!item.children || !item.children.length) {
      const r = item.route;
      if (!r) {
        return;
      }
      const url = r.startsWith('/') ? r : `/${r}`;
      if (item.openInNewTab) {
        const data: ConfirmOpenTabDialogData = {
          titleKey: 'sidebar.openCatalogConfirmTitle',
          messageKey: 'sidebar.openCatalogConfirmMessage',
          confirmKey: 'sidebar.openCatalogConfirmAccept',
          cancelKey: 'sidebar.openCatalogConfirmCancel',
        };
        this.dialog
          .open(ConfirmOpenTabDialogComponent, {
            width: '420px',
            maxWidth: '90vw',
            data,
          })
          .afterClosed()
          .subscribe((confirmed) => {
            if (!confirmed) {
              return;
            }
            const absolute =
              url.startsWith('http://') || url.startsWith('https://')
                ? url
                : `${window.location.origin}${url}`;
            window.open(absolute, '_blank', 'noopener,noreferrer');
          });
      } else {
        this.ngZone.run(() => {
          if (isPosShellEntryRoute(url)) {
            this.adminShellMode.enterPos(url === '/pos' ? POS_VENTA_ENTRY_ROUTE : url);
            return;
          }
          void this.router.navigateByUrl(url);
        });
      }
    }
  }
}
